"use client";

import {
  faCoins,
  faMoneyBill,
  faSackDollar,
} from "@fortawesome/free-solid-svg-icons";
import { faCoin } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormikContext } from "formik";

import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import Input from "@client/components/formik/input";
import Fieldset from "@client/components/lead-form/components/fieldset";

import { Tile } from "@ui/js/components/tiles/tile";

const INPUT_ID_AND_LABEL_HTMLFOR = "debt-amount";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);

export default function DebtAmount() {
  const { setFieldValue } = useFormikContext();

  const handleClick = (e: any) => {
    setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
  };
  return (
    <Fieldset legend="How much debt do you owe?">
      <Input
        type="hidden"
        name={FIELD_NAME_SELECTOR}
        id={INPUT_ID_AND_LABEL_HTMLFOR}
      />
      <Tile
        iconLeft={<FontAwesomeIcon icon={faCoin} />}
        label="$10k - $20k"
        value="$10k_to_$20k"
        onClick={handleClick}
      />
      <Tile
        iconLeft={<FontAwesomeIcon icon={faCoins} />}
        label="$20k - $40k"
        value="$20k_to_$40k"
        onClick={handleClick}
      />
      <Tile
        iconLeft={<FontAwesomeIcon icon={faMoneyBill} />}
        label="$40k - $100k"
        value="$40k_to_$100k"
        onClick={handleClick}
      />
      <Tile
        iconLeft={<FontAwesomeIcon icon={faSackDollar} />}
        label="Over $100k"
        value="over_$100k"
        onClick={handleClick}
      />
    </Fieldset>
  );
}
